import { LoginScenario } from '~/types/login'

export interface SimpleUserProfile {
  avatar?: string
  nickname?: string
  userHasPassword?: boolean
}

export interface LoginFields {
  email: string
  password: string
}
export interface LoginFieldsErrors {
  email: string
  password: string
}

export enum LOGIN_VIEW {
  CONTINUE_WITH_FACEBOOK = 'continueWithFacebook',
  CONTINUE_WITH_GOOGLE = 'continueWithGoogle',
  DEFAULT = 'default',
  ENTER_PASSWORD = 'enterPassword',
}

export interface LoginState {
  fields: LoginFields
  errors: LoginFieldsErrors
  backendError: string
  loginScenario: LoginScenario
  simpleUserProfile: SimpleUserProfile
  view: LOGIN_VIEW
}
